import { createFeatureSelector, createSelector } from '@ngrx/store';

import { CompaniesUIState } from '../company.types';
import { RouteState, State } from '../reducers';

export const getRouteState = createFeatureSelector<State, RouteState>('company');

export const selectCompaniesUIState = createSelector(
    getRouteState,
    ({ companiesUI }): CompaniesUIState => companiesUI
);

export const selectFilter = createSelector(
    selectCompaniesUIState,
    ({ filter }) => filter
);

export const selectCurrentCompanyId = createSelector(
    selectCompaniesUIState,
    ({ currentCompanyId }) => currentCompanyId
);

export const selectCurrentCompanyChanged = createSelector(
    selectCompaniesUIState,
    ({ currentCompanyIdChanged }) => currentCompanyIdChanged
);

export const selectCurrentPeriod = createSelector(
    selectCompaniesUIState,
    ({ currentPeriod }) => currentPeriod
);

export const selectCurrentPeriodChanged = createSelector(
    selectCompaniesUIState,
    ({ currentPeriodChanged }) => currentPeriodChanged
);
